import "jquery-ui";

(($:JQueryStatic) => {

    // Set the default region of all datepickers to New Zealand.
    $.datepicker.setDefaults($.datepicker.regional['en-NZ']);

    // This function attaches a datepicker to the selected element. It also allows the user to enter a 4- or 8-digit date without
    // slashes (of the form DDMM or DDMMYYYY) and automatically enter the slashes.
    $.fn.attachDatePickers = function (options) {

        var settings = $.extend({
            datepickerButtonImageUrl: null
        }, options);

        return this.each(function () {

            var picker = $(this);

            var defaultDate = null;
            var defaultDateString = picker.data("default-date");
            if (defaultDateString) {
                defaultDate = Date.parseExact(picker.data("default-date"), Ahb.INVARIANT_DATE_FORMAT_DATE_JS);
            }

            var buttonImage = settings.datepickerButtonImageUrl || picker.data("calendarimageurl");

            picker.datepicker({
                dateFormat: Ahb.NZ_DATE_FORMAT_JQUERY_UI,
                showOn: 'button',
                buttonImageOnly: true,
                buttonText: "",
                buttonImage: buttonImage,
                defaultDate: defaultDate,
                beforeShow: (element, n) => {
                    // For validation, add this to distinguish between blur events that occur as a result of the user
                    // clicking the calendar, from those which result from the user actually moving focus to a different control
                    $(element).data("showingcalendar", true);
                    return null;
                },
                onSelect: function () {
                    this.focus();
                    $(this).change();
                }
            });

            if (picker.prop('disabled')) {
                picker.datepicker('disable');
            }

            picker.next(".ui-datepicker-trigger").addClass('add-on');
            picker.next(".ui-datepicker-trigger").addClass('button-as-link');

            $(this).change(function (e) {

                // Only do anything if the value really has changed (by comparing to a data attribute value)
                var lastVal = $(this).data("lastchangeval");
                var val = $(this).val();
                if (lastVal !== val) {
                    $(this).data("lastchangeval", val);
                    e.preventDefault();
                    e.stopPropagation();

                    var formattedDate = Ahb.Utilities.stringToDate($(this).val());
                    $(this).val(formattedDate);

                    picker.trigger("change");
                }
            });
        });
    };
})(jQuery);



// WEBPACK FOOTER //
// ./ScriptsTS/dateeditorhookup.ts